// @flow

import React from "react";
import { Box } from "@chakra-ui/react";

import * as styles from "src/styles/auth";
import NavLinks from "src/components/auth/NavLinks";
import EmailSent from "src/components/SRW/EmailSent";

const VerificationMail = () => {
  return (
    <>
      <Box sx={styles.AuthContainer}>
        <EmailSent resumeSignup={true} />
      </Box>
      <NavLinks />
    </>
  );
};

export default VerificationMail;
